import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { getApiCall } from "../../../service/httpCall"; // Adjust the path if necessary
import Loader from "../../../components/partials/components/loader";
import ToastNotification from "../../../components/Toast";
import '@fortawesome/fontawesome-free/css/all.min.css';
import "../../../assets/custom/css/custom.css";
import { API_INCOMING_SUMMARY_LIST, DOWNLOAD_REPORT, API_INCOMING_REPORT_BY_DID_LIST } from '../../../service/url';
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { postApiCall } from '../../../service/httpCall';
import LottieAnimation from '../../../components/lottie/lottie';
import Modal from "react-bootstrap/Modal";
import moment from 'moment-timezone';
import { useNavigate } from 'react-router-dom';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { formatDateTime } from "../../../utilities/helpers";
import { USER_ROLES } from "../../../utilities/constant";
import exportData from "../../../utilities/export";
import { toast } from "react-toastify";


const IncomingSummary = () => {
  const [incomingSummary, setIncomingSummary] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [showSidePanel, setShowSidePanel] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedDid, setSelectedDid] = useState(null);
  const [didOptions, setDidOptions] = useState([]);
  const [showToastModal, setShowToastModal] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [incomingReport, setIncomingReport] = useState([])
  const [detailStartDate, setDetailStartDate] = useState('');
  const [detailEndDate, setDetailEndDate] = useState('');
  const [detailDid, setDetailDid] = useState(null);
  const navigate = useNavigate();
  const [loggedInUserId, setLoggedInUserId] = useState(null);
   const [usernames, setUsernames] = useState([]);
   const [selectedUsername, setSelectedUsername] = useState(null);
  const [loggedInUserRole, setLoggedInUserRole] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      const rawUser = await AsyncStorage.getItem('user');

      if (!rawUser) {
        console.error("User data not found in AsyncStorage");
        return;
      }

      let user;
      try {
        user = JSON.parse(rawUser);

        if (user) {
          setLoggedInUserId(user?.id);
          setLoggedInUserRole(user?.role);
        }
      } catch (e) {
        console.error("Invalid JSON in AsyncStorage user:", e);
        return;
      }
    };
    fetchUserData();
  })


  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .custom-scrollbar-panel::-webkit-scrollbar {
        width: 20px;
      }
  
      .custom-scrollbar-panel::-webkit-scrollbar-track {
        background: #f1f1f1;
      }
  
      .custom-scrollbar-panel::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 8px;
      }
  
      .custom-scrollbar-panel::-webkit-scrollbar-thumb:hover {
        background: #555;
      }
  
      .custom-scrollbar-panel {
        scrollbar-width: auto; /* for Firefox */
        scrollbar-color: #888 #f1f1f1;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);



  const showToasts = (message) => {
    setToastMessage(message);
    setShowToastModal(true);

    setTimeout(() => {
      setShowToastModal(false);
    }, 3000);
  };

  const handleFilter = () => {
    if ((!startDate || !endDate) && !selectedDid) {
      setFilteredData(incomingSummary);
      return;
    }

    const startOfDay = new Date(startDate);
    startOfDay.setHours(0, 0, 0, 0);

    const endOfDay = new Date(endDate);
    endOfDay.setHours(23, 59, 59, 999);

    let filtered = filteredData

    if (startDate || endDate) {
      filtered = incomingSummary.filter((data) => {
        const incommingData = new Date(data.schedule_date);
        return incommingData >= startOfDay && incommingData <= endOfDay;
      });
    }

    if (selectedDid) {
      filtered = filtered.filter(data => data.did == selectedDid);
    }
    if(selectedUsername){
      filtered = filtered.filter(data => data.username == selectedUsername);
    }

    setFilteredData(filtered);
  };

  const handleExport = async () => {
    await exportData("Incoming_Summary", setToastProps, setShowToast);
  };

  const fetchIncomingSummary = () => {
    getApiCall(API_INCOMING_SUMMARY_LIST)
      .then((resp) => {
        if (resp) {


      const uniqueUsernames = [
        ...new Set(
          resp.flatMap(item => [
            item.user?.username,
            item.parent?.username,
            item.sParent?.username
          ]).filter(Boolean)
        )
      ];
      setUsernames(uniqueUsernames);

          const updatedList = resp.map((val, idx) => {
            val['key'] = idx + 1;
            return val;
          });
          setIncomingSummary(updatedList)
          setFilteredData(updatedList)

          const uniqueDids = [...new Set(updatedList.map(item => item.did))];
          setDidOptions(uniqueDids.map(did => ({ label: did, value: did })));
        }
      })
      .catch((error) => {
        console.log(error)
      })
  };

  useEffect(() => {
    if (loggedInUserId) {
      fetchIncomingSummary();
    }
  }, [loggedInUserId]);

  const handleReset = () => {
    setStartDate(null);
    setEndDate(null);
    setSelectedDid(null);
    setFilteredData(incomingSummary);
  };

  const downloadFile = (rowData) => {
    if (!rowData) {
      console.error("Row data is missing.");
      return;
    }

    const params = {
      did: rowData.did,
      user_id: loggedInUserId,
      status: 0,
      report_type: 'full',
      schedule_date: rowData.schedule_date,
    }

    postApiCall(DOWNLOAD_REPORT, params)
      .then(onDownloadReportCreateSuccess)
      .catch(onDownloadReportCreateError);

    function onDownloadReportCreateSuccess(resp) {
      showToasts('Your Report Generation is in-progress')
    }

    function onDownloadReportCreateError(err) {
      // setButtonDisable(false);
      // setToastProps({ message: JSON.stringify(err), type: 'danger' });
          toast.error(JSON.stringify(err));
    }
  };


  const actionBodyTemplate = (rowData) => {
    return (
      <div className="d-flex justify-space-between gap-2">
        <button
          className="btn-icons m-1"
          onClick={() => downloadFile(rowData)}
          style={{ marginLeft: '8px', border: 'none', background: 'none', padding: '0' }}
        >
          <i className="fa fa-download" aria-hidden="true" style={{ color: 'blue', fontSize: '24px' }}></i>
        </button>
        <button
          className="btn-icons m-1"
          onClick={() => viewDetails(rowData)}
          style={{ border: 'none', background: 'none', padding: '0' }}
        >
          <i className="fa fa-eye" aria-hidden="true" style={{ color: 'blue', fontSize: '24px' }}></i>
        </button>

      </div>
    );
  };

  if (loading) {
    return <Loader />;
  }

  const viewDetails = (rowData) => {


    const scheduleDate = rowData?.schedule_date;

    const utcDateOnly = moment.utc(scheduleDate).format('YYYY-MM-DD');
    setDetailDid(rowData.did)
    const defaultStartDate = moment.tz(`${utcDateOnly} 00:00:00`, 'Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss');
    const defaultEndDate = moment.tz(`${utcDateOnly} 23:59:59`, 'Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss');

    navigate(`/did-report/${rowData.did}/${defaultStartDate}/${defaultEndDate}`);

    // setDetailStartDate(defaultStartDate)
    // setDetailEndDate(defaultEndDate)
    // getApiCall(`${API_INCOMING_REPORT_BY_DID_LIST}/${rowData.did}/${defaultStartDate}/${defaultEndDate}`)
    //         .then((resp) => {
    //            if (resp) {
    //             setIncomingReport(resp)
    //          }
    //         })
    //         .catch((error) => {
    //             console.log(error)
    //         })
    // setSelectedRow(rowData);
    // setShowSidePanel(true);
  };

  const handleDetailFilter = () => {
    getApiCall(`${API_INCOMING_REPORT_BY_DID_LIST}/${detailDid}/${detailStartDate}/${detailEndDate}`)
      .then((resp) => {
        if (resp) {
          setIncomingReport(resp)
        }
      })
      .catch((error) => {
        console.log(error)
      })
    setShowSidePanel(true);
  };

  const handleDetailClearFilter = (rowData) => {
    viewDetails(rowData)
  };

  return (
    <>
      <div>
        <div className="card" style={{ marginTop: "20px" }}>
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="card-title">{loggedInUserRole === USER_ROLES.CALL_CENTRE_AGENT ? "Outbound Summary" : "Incoming Summary"}</h4>
            {
                              filteredData.length > 0 && loggedInUserRole !== USER_ROLES.CALL_CENTRE_AGENT &&
                              <Button
                              label="Export Data"
                              onClick={handleExport}
                              className="p-button-active p-button-sm"
                              style={{ marginBottom: "10px", marginLeft: "10px" }}
                            >
                              
                            </Button>
                            }
          </div>
          <div className="card-body">
            <div className="d-flex align-items-center mb-3" style={{ marginLeft: "10px" }}>
              <Calendar
                value={startDate}
                onChange={(e) => setStartDate(e.value)}
                placeholder="Start Date"
                showIcon
              />
              <span className="mx-2">to</span>
              <Calendar
                value={endDate}
                onChange={(e) => setEndDate(e.value)}
                placeholder="End Date"
                showIcon
              />
              <Dropdown
                value={selectedDid}
                options={didOptions}
                onChange={(e) => setSelectedDid(e.value)}
                placeholder="Select DID"
                className="mx-2"
              />
              <Dropdown
                value={selectedUsername}
                options={usernames}
                onChange={(e) => setSelectedUsername(e.value)}
                placeholder="Select Username"
                className="mx-2"
              />
              <Button
                label="Filter"
                onClick={handleFilter}
                className="p-button-sm p-button-primary mx-2"
              />
              <Button
                label="Reset"
                onClick={handleReset}
                className="p-button-sm p-button-secondary"
              />
            </div>
            <div className="scroll-container">
              <DataTable
                value={filteredData}
                paginator
                rows={10}
                tableStyle={{ minWidth: "50rem" }}
              >
                <Column field="did" header="Did" filterPlaceholder="Search by name" />
                <Column field="user_id" header="User Id" filterPlaceholder="Search by URL" />
                <Column field="user.username" header="Username" filterPlaceholder="Search by URL" />
                <Column
                  field="schedule_date"
                  header="Schedule Date"
                  body={(rowData) =>formatDateTime(rowData.schedule_date)}
                />

                <Column field="nos_processed" header="Total Nos" filterPlaceholder="Search by category" />
                <Column field="connected_calls" header="Connected Calls" filterPlaceholder="Search by URL" />
                <Column field="sms_count" header="SMS Count" filterPlaceholder="Search by duration" />
                <Column field="billing_duration" header="Billing Duration" filterPlaceholder="Search by category" />
                <Column field="dtmf_count" header="Dtmf Count" filterPlaceholder="Search by category" />
                <Column field="retry_count" header="Retry Count" filterPlaceholder="Search by category" />
                <Column field="webhook_count" header="Webhook Count" filterPlaceholder="Search by category" />
                <Column
                  header="Actions"
                  body={actionBodyTemplate}
                  style={{ textAlign: "center", width: "12rem" }}
                />
              </DataTable>
            </div>
          </div>
        </div>
        {/* <ToastNotification
          show_toast={showToast}
          set_show_toast={setShowToast}
          {...toastProps}
        /> */}
        {/* LOTTIE MODEL FOR TOAST */}
        <Modal show={showToastModal} centered onHide={() => setShowToastModal(false)} size="sm">
          <Modal.Body className="text-center">
            <h5>{toastMessage}</h5>
            <LottieAnimation animationData={"https://assets6.lottiefiles.com/packages/lf20_touohxv0.json"} />
          </Modal.Body>
        </Modal>
      </div>

      {showSidePanel && (
        <div
          className="custom-scrollbar-panel"
          style={{
            position: 'fixed',
            top: 0,
            right: 0,
            width: '1500px',
            height: '100%',
            backgroundColor: '#fff',
            borderLeft: '1px solid #ddd',
            boxShadow: '-2px 0 5px rgba(0,0,0,0.1)',
            zIndex: 1050,
            overflowY: 'auto',
            transition: 'transform 0.3s ease-in-out',
            padding: '15px',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '20px',
            }}
          >
            <h5 style={{ margin: 0 }}>Detail View</h5>
            <button
              onClick={() => setShowSidePanel(false)}
              style={{
                border: 'none',
                backgroundColor: '#dc3545',
                color: '#fff',
                borderRadius: '3px',
                padding: '5px 10px',
                cursor: 'pointer',
              }}
            >
              <i className="fa fa-times" aria-hidden="true" style={{ fontSize: '16px' }}></i>
            </button>
          </div>

          <div>
            <p><strong>DID:</strong> {selectedRow?.did}</p>
            <p><strong>User ID:</strong> {selectedRow?.user_id?.id}</p>
            <p><strong>Schedule Date:</strong> {new Date(selectedRow?.schedule_date).toUTCString()}</p>
            <p><strong>Nos Processed:</strong> {selectedRow?.nos_processed}</p>
            <p><strong>Connected Calls:</strong> {selectedRow?.connected_calls}</p>
            <p><strong>Total Nos:</strong> {selectedRow?.total_nos}</p>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label><strong>Start Date:</strong></label>
              <input
                type="datetime-local"
                value={detailStartDate}
                onChange={(e) => setDetailStartDate(e.target.value)}
                style={{ padding: '5px', minWidth: '220px' }}
              />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label><strong>End Date:</strong></label>
              <input
                type="datetime-local"
                value={detailEndDate}
                onChange={(e) => setDetailEndDate(e.target.value)}
                style={{ padding: '5px', minWidth: '220px' }}
              />
            </div>

            <button
              onClick={handleDetailFilter}
              style={{
                marginTop: '22px',
                padding: '7px 12px',
                backgroundColor: '#007bff',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
              Filter
            </button>

            <button
              onClick={() => handleDetailClearFilter(selectedRow)}
              style={{
                marginTop: '22px',
                padding: '7px 12px',
                backgroundColor: '#6c757d',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
              Clear Filter
            </button>
          </div>

          <div className="scroll-container">
            <DataTable
              value={incomingReport}
              paginator
              rows={10}
              tableStyle={{ minWidth: "50rem" }}
            >
              <Column field="user_id" header="User Id" filterPlaceholder="Search by URL" />

              <Column field="caller_number" header="Caller Number" filterPlaceholder="Search by category" />
              <Column field="callee_number" header="Callee Number" filterPlaceholder="Search by name" />
              <Column
                field="start_time"
                header="Start Time"
                body={(val) => new Date(val['start_time']).toUTCString()}
              />
              <Column
                field="end_time"
                header="End Time"
                body={(val) => new Date(val['end_time']).toUTCString()}
              />
            </DataTable>
          </div>
        </div>
      )}

    </>
  );
};

export default IncomingSummary;
